import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e44994"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-search-option" }
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]

import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'
import { editPageData } from '@/service/main/system'
import { getMenuTitle } from '@/utils/menu-title'

interface MenuSearchItem {
  value: string
  name: string
  breadcrumb: string
  uri: string
  routePath: string
  menu: any
  order: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuSearch',
  setup(__props) {

const store = useStore()
const router = useRouter()
const keyword = ref('')

const flattenMenus = (
  menus: unknown,
  parentNames: string[] = [],
  result: MenuSearchItem[] = []
) => {
  const safeMenus = Array.isArray(menus) ? menus : []
  for (const menu of safeMenus) {
    if (!menu || typeof menu !== 'object' || Array.isArray(menu)) continue

    const name = getMenuTitle(
      store.state.login.userInfo.empNo,
      String(menu.name || '').trim()
    )
    const currentNames = name ? [...parentNames, name] : parentNames
    const uri = String(menu.uri || '').trim()

    if (uri) {
      result.push({
        value: name || uri,
        name,
        breadcrumb: currentNames.join(' / '),
        uri,
        routePath: String(menu.path || '').trim(),
        menu,
        order: result.length
      })
    }

    if (Array.isArray(menu.children)) {
      flattenMenus(menu.children, currentNames, result)
    }
  }

  return result
}

const menuOptions = computed(() => flattenMenus(store.state.login.userMenu))

const getMatchScore = (item: MenuSearchItem, query: string) => {
  const name = item.name.toLocaleLowerCase()
  const breadcrumb = item.breadcrumb.toLocaleLowerCase()
  const uri = item.uri.toLocaleLowerCase()
  const routePath = item.routePath.toLocaleLowerCase()

  if (name === query) return 0
  if (name.startsWith(query)) return 1
  if (name.includes(query)) return 2
  if (breadcrumb.includes(query)) return 3
  if (uri.startsWith(query)) return 4
  if (uri.includes(query)) return 5
  if (routePath.includes(query)) return 6
  return -1
}

const querySearch = (
  queryString: string,
  callback: (results: MenuSearchItem[]) => void
) => {
  const query = queryString.trim().toLocaleLowerCase()
  if (!query) {
    callback([])
    return
  }

  const results = menuOptions.value
    .map((item) => ({ item, score: getMatchScore(item, query) }))
    .filter(({ score }) => score >= 0)
    .sort((a, b) => a.score - b.score || a.item.order - b.item.order)
    .slice(0, 20)
    .map(({ item }) => item)

  callback(results)
}

const handleSelect = (item: MenuSearchItem) => {
  keyword.value = ''
  editPageData('/main/topHit/hit', item.menu)
    .then(() => router.push(item.uri))
    .catch(() => router.push(item.uri))
}

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!

  return (_openBlock(), _createBlock(_component_el_autocomplete, {
    modelValue: keyword.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
    class: "menu-search",
    "popper-class": "menu-search-popper",
    "prefix-icon": "el-icon-search",
    placeholder: "搜索菜单名称或路径",
    "fetch-suggestions": querySearch,
    "trigger-on-focus": false,
    "highlight-first-item": true,
    clearable: "",
    onSelect: handleSelect
  }, {
    default: _withCtx(({ item }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "menu-search-option__name",
          title: item.breadcrumb
        }, _toDisplayString(item.breadcrumb), 9, _hoisted_2),
        _createElementVNode("span", {
          class: "menu-search-option__path",
          title: item.uri
        }, _toDisplayString(item.uri), 9, _hoisted_3)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})